

import { showMessages } from '../../components/AlertMessages/AlertMessages';
import { P218GetDataList } from '../../service/200/P218Service';

export const onP218GetDataList = (setLoading,dataReq,setData,toast) => {
    setLoading(true);
    P218GetDataList(dataReq).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        col1 : element.itemNo,
                        col2 : element.itemDesc,
                        col3 : element.itemUnitDesc,
                        col4 : element.itemUnitPrice,
                        col5 : element.contractAmount,
                        col6 : element.bookAmount,
                        col7 : element.withdrawAmoun,
                        col8 : element.pendingAmount
                    });
                    index++;
                });
                setData(temp);
            } else {
                showMessages(toast,"error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
            }
        },
        function (err) {
            if (err.response && err.response.data.status === 401) {
                alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                window.location.href = "/login";
            } else {
                showMessages(toast,"error", `เกิดข้อผิดพลาด : ${err} `, "");
            }
            setLoading(false);
        }
    );
};